define('views/pages/organization/users/table',['require','jquery','underscore','views/base/view','views/base/collection','text!templates/pages/organization/users/table.ejs','text!templates/pages/organization/users/table-row.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        View = require('views/base/view'),
        CollectionView = require('views/base/collection'),
        templateTable = require('text!templates/pages/organization/users/table.ejs'),
        templateTableRow = require('text!templates/pages/organization/users/table-row.ejs');

    /*
        ORGANIZATION USERS TABLE ROW
    */

    var OrganizationUsersRowView = View.extend({
        template: templateTableRow,
        className: 'users-table-row',
        tagName: 'tr',
        listen: {
            'change:selected model': 'render'
        },
        clickRow: function(ev) {
            ev.stopPropagation();
            ev.preventDefault();

            this.model.set('selected', true);

            if ($(ev.target).hasClass('btn-mini')) {
                this.model.collection.trigger('delete');
            }
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            if (this.model.get('selected')) {
                this.$el.addClass('active');
            } else {
                this.$el.removeClass('active');
            }
            this.bindEvents();
        },
        bindEvents: function() {
            this.$el.off('click').on('click', _.bind(this.clickRow, this));
        }
    });


    /*
        ORGANIZATION USERS TABLE
    */

    var OrganizationUsersTableView = CollectionView.extend({
        region: 'organization-users-table',
        autoRender: true,
        itemView: OrganizationUsersRowView,
        animationDuration: 0,
        template: templateTable,
        listSelector: 'tbody',
        loadingSelector: '.loading',
        fallbackSelector: '.empty',
        listen: {
            'addedToDOM': 'onAddedToDOM'
        },
        onAddedToDOM: function() {
            _.each(this.getItemViews(), function(view) {
                view.bindEvents();
            });
        },
        render: function() {
            CollectionView.prototype.render.apply(this, arguments);

            if (document.body.contains(this.el)) {
                this.onAddedToDOM();
            }
        }
    });


    return OrganizationUsersTableView;
});
